import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './QuestionsManager.css';
import API_BASE_URL from '../config';
import { toast } from "react-toastify";

// Import React Icons
import { 
  FiFileText, FiBook, FiCode, FiTarget, FiDatabase, 
  FiClipboard, FiBookOpen, FiTrendingUp, FiActivity,
  FiGrid, FiLayers, FiPackage, FiShoppingBag, FiBriefcase,
  FiHome, FiHeart, FiDollarSign, FiShoppingCart, FiCreditCard,
  FiTruck, FiBuilding, FiWifi, FiZap, FiMapPin, FiUsers,
  FiCheckCircle, FiAlertCircle, FiEdit2, FiTrash2,
  FiPlus, FiMinus, FiX, FiSearch, FiFilter, FiClock,
  FiTag, FiHash, FiCalendar, FiUser, FiMail,
  FiArrowUp, FiArrowDown, FiChevronDown, FiChevronUp,
  FiSettings, FiTool, FiBox, FiPieChart, FiBarChart2,
  FiDroplet, FiThermometer, FiWind, FiCloud, FiSun,
  FiMoon, FiCoffee, FiMusic, FiSmile, FiStar
} from 'react-icons/fi';

import {
  FaHospital, FaUniversity, FaIndustry, FaStore,
  FaHotel, FaPhoneAlt, FaChargingStation, FaLandmark,
  FaQuestionCircle, FaExclamationCircle, FaStar as FaStarIcon,
  FaRegStar, FaUserTie, FaGraduationCap, FaHammer,
  FaOilCan, FaTractor, FaPlane, FaShip,
  FaBuilding as FaBuildingIcon, FaHospitalAlt,
  FaMoneyBillWave, FaBook, FaBookReader,
  FaUserMd, FaUserNurse, FaStethoscope,
  FaPiggyBank, FaChartLine, FaCalculator,
  FaBalanceScale, FaIndustry as FaIndustryIcon,
  FaRobot, FaCogs, FaWrench, FaTools,
  FaShieldAlt, FaLock, FaKey, FaUserShield,
  FaUserCheck, FaUserTimes, FaUserPlus,
  FaUserMinus, FaUserEdit, FaUserSecret
} from 'react-icons/fa';

import {
  GiFactory, GiNurseMale, GiMoneyStack, GiTeacher,
  GiChefToque, GiDeliveryDrone, GiCrane, GiRadarDish,
  GiPowerGenerator, GiGovernment, GiMedicalPack,
  GiReceiveMoney, GiFactoryArm, GiShoppingCart as GiShoppingCartIcon,
  GiBookshelf, GiConverseShoe, GiMechanicGarage,
  GiEnergyBreath, GiHouse, GiRank3, GiRank2,
  GiRank1, GiFactory as GiFactoryIcon,
  GiNurseFemale, GiDoctorFace, GiPill, GiHealthNormal,
  GiBank, GiPayMoney, GiCash, GiMultipleTargets,
  GiFactory as GiFactory2, GiSteelClaws, GearHammer,
  GiProcessor, GiCircuitry, GiMineTruck, GiDigDug,
  GiDigHole, GiMining, GiOilPump, GiPowerLightning,
  GiElectric, GiLightningArc, GiLightningStorm,
  GiAncientColumns, GiCapital, GiCourthouse,
  GiScaleMail, GiJusticeStar, GiBookmarklet,
  GiSandsOfTime, GiTimeBomb, GiStopwatch,
  GiAlarmClock, GiHourglass, GiPocketWatch
} from 'react-icons/gi';

import { 
  HiOutlineDocumentText,
  HiOutlineDocumentAdd,
  HiOutlineDocumentRemove,
  HiOutlineDocumentDuplicate,
  HiOutlineDocumentDownload,
  HiOutlineQuestionMarkCircle,
  HiOutlineExclamationCircle,
  HiOutlineAcademicCap,
  HiOutlineBriefcase,
  HiOutlineHome,
  HiOutlineOfficeBuilding,
  HiOutlineShoppingBag,
  HiOutlineTruck,
  HiOutlineCog,
  HiOutlineChartBar,
  HiOutlineChartPie,
  HiOutlineCurrencyDollar,
  HiOutlineCreditCard,
  HiOutlineLibrary,
  HiOutlineBeaker,
  HiOutlineTerminal,
  HiOutlineDesktopComputer,
  HiOutlineServer,
  HiOutlineChip,
  HiOutlineGlobe,
  HiOutlineCloud,
  HiOutlineKey,
  HiOutlineLockClosed,
  HiOutlineShieldCheck,
  HiOutlineUserGroup,
  HiOutlineUser,
  HiOutlineUserAdd,
  HiOutlineUserRemove,
  HiOutlineUserCircle,
  HiOutlineIdentification,
  HiOutlineBadgeCheck
} from 'react-icons/hi';

import {
  MdLocalHospital,
  MdSchool,
  MdFactory,
  MdStore,
  MdHotel,
  MdLocalShipping,
  MdConstruction,
  MdPhoneIphone,
  MdPower,
  MdAccountBalance,
  MdWork,
  MdBusinessCenter,
  MdBusiness,
  MdStorefront,
  MdLocalGroceryStore,
  MdRestaurant,
  MdLocalCafe,
  MdLocalBar,
  MdLocalPharmacy,
  MdLocalGasStation,
  MdLocalCarWash,
  MdLocalAirport,
  MdLocalTaxi,
  MdLocalParking,
  MdLocalAtm,
  MdLocalOffer,
  MdLocalPlay,
  MdLocalMovies,
  MdLocalLibrary,
  MdLocalConvenienceStore,
  MdDirectionsCar,
  MdDirectionsBoat,
  MdDirectionsBus,
  MdDirectionsRailway,
  MdDirectionsWalk,
  MdDirectionsBike,
  MdDirectionsTransit,
  MdDirections,
  MdMyLocation,
  MdLocationOn,
  MdLocationCity,
  MdLocationSearching
} from 'react-icons/md';

const QuestionsManager = () => {
  const [questions, setQuestions] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [categories, setCategories] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [industryFilter, setIndustryFilter] = useState('all');
  const [jobPositionFilter, setJobPositionFilter] = useState('all');
  const [jobPositions, setJobPositions] = useState([]);
  const [requirements, setRequirements] = useState([]);
  const [customIndustries, setCustomIndustries] = useState([]);

  // Industry-specific question types - Updated with React Icons
  const questionTypesByIndustry = {
    it: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'coding', label: 'Coding Challenge', icon: <FiCode /> },
      { value: 'system_design', label: 'System Design', icon: <FiLayers /> },
      { value: 'debugging', label: 'Debugging', icon: <FiActivity /> },
      { value: 'sql', label: 'SQL Query', icon: <FiDatabase /> },
      { value: 'architecture', label: 'Technical Architecture', icon: <FiPackage /> },
      { value: 'scenario', label: 'Scenario Based', icon: <FiTarget /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    healthcare: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'medical_scenario', label: 'Medical Scenario', icon: <FaHospital /> },
      { value: 'patient_management', label: 'Patient Management', icon: <FiUsers /> },
      { value: 'clinical_reasoning', label: 'Clinical Reasoning', icon: <GiMedicalPack /> },
      { value: 'ethics', label: 'Medical Ethics', icon: <FiHeart /> },
      { value: 'protocol', label: 'Medical Protocols', icon: <FiClipboard /> },
      { value: 'case_study', label: 'Case Study', icon: <FiBookOpen /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    finance: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'financial_analysis', label: 'Financial Analysis', icon: <FiTrendingUp /> },
      { value: 'risk_assessment', label: 'Risk Assessment', icon: <FiTarget /> },
      { value: 'calculation', label: 'Financial Calculation', icon: <GiMoneyStack /> },
      { value: 'regulation', label: 'Regulatory Compliance', icon: <FiHeart /> },
      { value: 'investment', label: 'Investment Strategy', icon: <GiReceiveMoney /> },
      { value: 'case_study', label: 'Case Study', icon: <FiBookOpen /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    manufacturing: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'safety_procedure', label: 'Safety Procedures', icon: <HiOutlineShieldCheck /> },
      { value: 'quality_control', label: 'Quality Control', icon: <FiCheckCircle /> },
      { value: 'process_improvement', label: 'Process Improvement', icon: <FiActivity /> },
      { value: 'technical_drawing', label: 'Technical Drawing', icon: <FiGrid /> },
      { value: 'equipment_operation', label: 'Equipment Operation', icon: <FiSettings /> },
      { value: 'scenario', label: 'Scenario Based', icon: <FiTarget /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    retail: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'customer_service', label: 'Customer Service', icon: <FiUsers /> },
      { value: 'sales_scenario', label: 'Sales Scenario', icon: <FiDollarSign /> },
      { value: 'inventory_management', label: 'Inventory Management', icon: <FiPackage /> },
      { value: 'visual_merchandising', label: 'Visual Merchandising', icon: <FiShoppingBag /> },
      { value: 'conflict_resolution', label: 'Conflict Resolution', icon: <FiActivity /> },
      { value: 'product_knowledge', label: 'Product Knowledge', icon: <FiTarget /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    education: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'lesson_planning', label: 'Lesson Planning', icon: <FiBook /> },
      { value: 'classroom_management', label: 'Classroom Management', icon: <FaGraduationCap /> },
      { value: 'pedagogy', label: 'Teaching Methodology', icon: <GiTeacher /> },
      { value: 'assessment_design', label: 'Assessment Design', icon: <HiOutlineDocumentText /> },
      { value: 'student_engagement', label: 'Student Engagement', icon: <FiTarget /> },
      { value: 'parent_communication', label: 'Parent Communication', icon: <FaPhoneAlt /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    hospitality: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'guest_service', label: 'Guest Service Scenario', icon: <FaHotel /> },
      { value: 'safety_procedure', label: 'Safety & Emergency', icon: <HiOutlineShieldCheck /> },
      { value: 'culinary', label: 'Culinary Knowledge', icon: <GiChefToque /> },
      { value: 'housekeeping', label: 'Housekeeping Standards', icon: <FiHome /> },
      { value: 'reservation', label: 'Reservation Management', icon: <FiCalendar /> },
      { value: 'conflict_resolution', label: 'Conflict Resolution', icon: <FiActivity /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    logistics: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'supply_chain', label: 'Supply Chain Management', icon: <FiTruck /> },
      { value: 'inventory_control', label: 'Inventory Control', icon: <FiPackage /> },
      { value: 'safety_procedure', label: 'Safety Procedures', icon: <HiOutlineShieldCheck /> },
      { value: 'route_planning', label: 'Route Planning', icon: <FiMapPin /> },
      { value: 'customs', label: 'Customs & Compliance', icon: <FiClipboard /> },
      { value: 'scenario', label: 'Operational Scenario', icon: <FiTarget /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    construction: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'safety_procedure', label: 'Safety Protocols', icon: <HiOutlineShieldCheck /> },
      { value: 'blueprint_reading', label: 'Blueprint Reading', icon: <FiGrid /> },
      { value: 'material_knowledge', label: 'Material Knowledge', icon: <FaHammer /> },
      { value: 'equipment_operation', label: 'Equipment Operation', icon: <GiCrane /> },
      { value: 'project_management', label: 'Project Management', icon: <FiClipboard /> },
      { value: 'quality_control', label: 'Quality Control', icon: <FiCheckCircle /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    telecom: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'technical_troubleshooting', label: 'Technical Troubleshooting', icon: <FiTool /> },
      { value: 'network_architecture', label: 'Network Architecture', icon: <FiWifi /> },
      { value: 'customer_service', label: 'Customer Service', icon: <FaPhoneAlt /> },
      { value: 'safety_procedure', label: 'Safety Procedures', icon: <HiOutlineShieldCheck /> },
      { value: 'protocol_knowledge', label: 'Protocol Knowledge', icon: <FiDatabase /> },
      { value: 'scenario', label: 'Service Scenario', icon: <FiTarget /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    energy: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'safety_procedure', label: 'Safety Protocols', icon: <HiOutlineShieldCheck /> },
      { value: 'technical_operation', label: 'Technical Operation', icon: <GiPowerGenerator /> },
      { value: 'emergency_response', label: 'Emergency Response', icon: <FiActivity /> },
      { value: 'regulation', label: 'Regulatory Compliance', icon: <FiHeart /> },
      { value: 'maintenance', label: 'Maintenance Procedures', icon: <FiTool /> },
      { value: 'environmental', label: 'Environmental Safety', icon: <FiZap /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    government: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'policy_knowledge', label: 'Policy Knowledge', icon: <FiClipboard /> },
      { value: 'public_service', label: 'Public Service Scenario', icon: <FaLandmark /> },
      { value: 'regulation', label: 'Regulatory Compliance', icon: <FiHeart /> },
      { value: 'ethics', label: 'Ethical Scenarios', icon: <FiTarget /> },
      { value: 'procedure', label: 'Administrative Procedures', icon: <FiFileText /> },
      { value: 'case_study', label: 'Case Study', icon: <FiBookOpen /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> }
    ],
    other: [
      { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
      { value: 'text', label: 'Text Answer', icon: <FiFileText /> },
      { value: 'scenario', label: 'Scenario Based', icon: <FiTarget /> },
      { value: 'case_study', label: 'Case Study', icon: <FiBookOpen /> }
    ]
  };

  // Industries list with React Icons
  const industries = [
    { value: 'all', label: 'All Industries', icon: <FaBuildingIcon /> },
    { value: 'it', label: 'Information Technology', icon: <HiOutlineDesktopComputer /> },
    { value: 'healthcare', label: 'Healthcare & Medical', icon: <FaHospital /> },
    { value: 'finance', label: 'Banking & Finance', icon: <FiDollarSign /> },
    { value: 'manufacturing', label: 'Manufacturing', icon: <GiFactory /> },
    { value: 'retail', label: 'Retail & E-commerce', icon: <FiShoppingBag /> },
    { value: 'education', label: 'Education', icon: <FaGraduationCap /> },
    { value: 'hospitality', label: 'Hospitality', icon: <FaHotel /> },
    { value: 'logistics', label: 'Logistics & Supply Chain', icon: <FiTruck /> },
    { value: 'construction', label: 'Construction', icon: <GiCrane /> },
    { value: 'telecom', label: 'Telecommunications', icon: <FaPhoneAlt /> },
    { value: 'energy', label: 'Energy & Utilities', icon: <GiPowerGenerator /> },
    { value: 'government', label: 'Government', icon: <FaLandmark /> },
    { value: 'other', label: 'Other (Custom)', icon: <FiPlus /> }
  ];

  const [newQuestion, setNewQuestion] = useState({
    question: '',
    type: 'multiple_choice',
    options: ['', '', ''],
    correctAnswer: '',
    difficulty: 'Medium',
    category: '',
    tags: [],
    timeLimit: 60,
    industry: 'it',
    customIndustry: '',
    programmingLanguage: '',
    scenarioContext: '',
    jobPosition: ''
  });

  // Get current user from session storage
  useEffect(() => {
    const getUserFromSession = () => {
      try {
        const userDataString = sessionStorage.getItem('userData');
        
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          console.log('👤 Current user for questions:', userData);
          
          const userInfo = {
            email: userData.email,
            name: userData.name || userData.userName || 'User'
          };
          
          setCurrentUser(userInfo);
          console.log('✅ User set for questions (email):', userInfo.email);
        } else {
          console.log('❌ No user data found in session storage');
        }
      } catch (error) {
        console.error('❌ Error getting user from session:', error);
      }
    };

    getUserFromSession();
  }, []);

  // Load job requirements to get positions
  const loadJobRequirements = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(`${API_BASE_URL}/api/requirements`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.success) {
        const requirementsData = response.data.data || [];
        setRequirements(requirementsData);
        
        // Extract unique job positions
        const positions = [...new Set(requirementsData.map(req => req.position))].filter(Boolean);
        setJobPositions(positions);
        console.log('📋 Loaded job positions:', positions);
      }
    } catch (error) {
      console.error('Error loading job requirements:', error);
    }
  };

  // Load custom industries
  const loadCustomIndustries = async () => {
    try {
      if (!currentUser) return;
      
      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(`${API_BASE_URL}/api/questions/custom-industries`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: {
          userEmail: currentUser.email
        }
      });

      if (response.data.success) {
        setCustomIndustries(response.data.data);
        console.log('🏭 Loaded custom industries:', response.data.data);
      }
    } catch (error) {
      console.error('Error loading custom industries:', error);
    }
  };

  useEffect(() => {
    if (currentUser) {
      loadQuestions();
      loadCategories();
      loadJobRequirements();
      loadCustomIndustries();
    }
  }, [filter, searchTerm, currentUser, industryFilter, jobPositionFilter]);

  // Get all industries including custom ones
  const getAllIndustries = () => {
    const allIndustries = [...industries.filter(ind => ind.value !== 'other')];
    
    // Add custom industries as options
    customIndustries.forEach(customInd => {
      allIndustries.push({
        value: customInd,
        label: customInd,
        icon: <FaBuildingIcon />,
        isCustom: true
      });
    });
    
    // Add "Other" option at the end
    allIndustries.push(industries.find(ind => ind.value === 'other'));
    
    return allIndustries;
  };

  // Filter questions based on industry, type, and job position
  const filteredQuestions = questions.filter(question => {
    const matchesIndustry = industryFilter === 'all' || 
      question.industry === industryFilter ||
      (industryFilter === 'other' && !industries.find(ind => ind.value === question.industry));
    
    const matchesType = filter === 'all' || question.type === filter;
    const matchesJobPosition = jobPositionFilter === 'all' || question.jobPosition === jobPositionFilter;
    const matchesSearch = searchTerm === '' || 
      question.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      question.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (question.tags && question.tags.some(tag => 
        tag.toLowerCase().includes(searchTerm.toLowerCase())
      )) ||
      (question.jobPosition && question.jobPosition.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (question.industry && question.industry.toLowerCase().includes(searchTerm.toLowerCase()));
    
    return matchesIndustry && matchesType && matchesJobPosition && matchesSearch;
  });

  // Get current industry's question types for filter tabs
  const getCurrentIndustryTypes = () => {
    if (industryFilter === 'all') {
      return [
        { value: 'all', label: 'All Types', icon: <FiGrid /> },
        { value: 'multiple_choice', label: 'Multiple Choice', icon: <FiCheckCircle /> },
        { value: 'coding', label: 'Coding', icon: <FiCode /> },
        { value: 'text', label: 'Text Answer', icon: <FiFileText /> },
        { value: 'scenario', label: 'Scenario Based', icon: <FiTarget /> },
        { value: 'case_study', label: 'Case Study', icon: <FiBookOpen /> }
      ];
    }
    
    const industryTypes = questionTypesByIndustry[industryFilter] || questionTypesByIndustry.other;
    return [
      { value: 'all', label: 'All Types', icon: <FiGrid /> },
      ...industryTypes
    ];
  };

  const currentIndustryTypes = getCurrentIndustryTypes();

  // Get stats for current industry
  const getIndustryStats = () => {
    let industryQuestions;
    
    if (industryFilter === 'all') {
      industryQuestions = questions;
    } else if (industryFilter === 'other') {
      // Filter for custom industries (not in predefined list)
      industryQuestions = questions.filter(q => 
        !industries.find(ind => ind.value === q.industry && ind.value !== 'other')
      );
    } else {
      industryQuestions = questions.filter(q => q.industry === industryFilter);
    }

    const totalQuestions = industryQuestions.length;
    const multipleChoice = industryQuestions.filter(q => q.type === 'multiple_choice').length;
    const codingQuestions = industryQuestions.filter(q => q.type === 'coding').length;
    const scenarioQuestions = industryQuestions.filter(q => 
      q.type.includes('scenario') || q.type.includes('case_study')
    ).length;

    return {
      totalQuestions,
      multipleChoice,
      codingQuestions,
      scenarioQuestions
    };
  };

  const stats = getIndustryStats();

  const loadQuestions = async () => {
    try {
      if (!currentUser) {
        console.log('No current user found');
        setLoading(false);
        return;
      }

      setLoading(true);
      const token = sessionStorage.getItem('authToken');
      console.log('🔄 Loading questions for user email:', currentUser.email);
      
      const response = await axios.get(`${API_BASE_URL}/api/questions`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        params: { 
          type: filter !== 'all' ? filter : undefined, 
          search: searchTerm,
          userEmail: currentUser.email
        }
      });

      if (response.data.success) {
        setQuestions(response.data.data);
        console.log(`📝 Loaded ${response.data.data.length} questions for user: ${currentUser.email}`);
      } else {
        console.error('Failed to load questions:', response.data.message);
        toast.error('Failed to load questions');
      }
    } catch (error) {
      console.error('Error loading questions:', error);
      toast.error('Error loading questions. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const loadCategories = async () => {
    try {
      if (!currentUser) return;

      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(`${API_BASE_URL}/api/questions/categories`, {
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        params: {
          userEmail: currentUser.email
        }
      });

      if (response.data.success) {
        setCategories(response.data.data);
        console.log('✅ Loaded categories:', response.data.data.length);
      }
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  // Helper function to get department from position
  const getDepartmentFromPosition = (position) => {
    const requirement = requirements.find(req => req.position === position);
    return requirement ? requirement.department : '';
  };

  // Helper function to get industry from department
  const getIndustryFromDepartment = (department) => {
    const industryMap = {
      'IT': 'it',
      'Technology': 'it',
      'Engineering': 'it',
      'Healthcare': 'healthcare',
      'Medical': 'healthcare',
      'Finance': 'finance',
      'Accounting': 'finance',
      'Banking': 'finance',
      'Manufacturing': 'manufacturing',
      'Production': 'manufacturing',
      'Retail': 'retail',
      'Sales': 'retail',
      'Education': 'education',
      'Teaching': 'education',
      'Hospitality': 'hospitality',
      'Hotel': 'hospitality',
      'Logistics': 'logistics',
      'Supply Chain': 'logistics',
      'Construction': 'construction',
      'Telecom': 'telecom',
      'Energy': 'energy',
      'Government': 'government'
    };
    
    return industryMap[department] || 'other';
  };

  // Helper function to get suggested categories based on position
  const getSuggestedCategories = (position) => {
    const categorySuggestions = {
      'Frontend Developer': ['JavaScript', 'React', 'HTML/CSS', 'UI/UX', 'Frontend Architecture'],
      'Backend Developer': ['Node.js', 'Python', 'Database', 'API Design', 'System Design'],
      'Full Stack Developer': ['JavaScript', 'React', 'Node.js', 'Full Stack', 'System Design'],
      'DevOps Engineer': ['AWS', 'Docker', 'CI/CD', 'Infrastructure', 'Cloud Computing'],
      'Data Scientist': ['Python', 'Machine Learning', 'Statistics', 'Data Analysis', 'AI'],
      'Software Engineer': ['Algorithms', 'Data Structures', 'OOP', 'System Design', 'Software Development'],
      'QA Engineer': ['Testing', 'Automation', 'Selenium', 'Quality Assurance', 'Test Cases'],
      'UI/UX Designer': ['Design Principles', 'User Research', 'Wireframing', 'Prototyping', 'Figma'],
      'Product Manager': ['Product Strategy', 'User Stories', 'Agile', 'Roadmapping', 'Market Research'],
      'Project Manager': ['Project Planning', 'Risk Management', 'Stakeholder Management', 'Agile/Scrum'],
      'Accounts Staff': ['Accounting Principles', 'Bookkeeping', 'Taxation', 'Financial Reporting', 'Payroll'],
      'HR Manager': ['Recruitment', 'Employee Relations', 'Compensation', 'Training & Development', 'Labor Laws'],
      'Sales Executive': ['Sales Techniques', 'CRM', 'Negotiation', 'Client Management', 'Product Knowledge']
    };
    
    return categorySuggestions[position] || ['General Knowledge'];
  };

  const handleCreateQuestion = async () => {
    try {
      if (!currentUser || !currentUser.email) {
        toast.error('User not found. Please login again.');
        return;
      }

      const token = sessionStorage.getItem('authToken');
      
      if (!newQuestion.question.trim()) {
        toast.error('Please enter a question');
        return;
      }

      if (!newQuestion.category.trim()) {
        toast.error('Please enter a category');
        return;
      }

      if (!newQuestion.jobPosition.trim()) {
        toast.error('Please select a job position for this question');
        return;
      }

      // Handle custom industry
      let finalIndustry = newQuestion.industry;
      if (newQuestion.industry === 'other' && newQuestion.customIndustry.trim()) {
        finalIndustry = newQuestion.customIndustry.trim();
        
        // Save custom industry to database
        try {
          await axios.post(
            `${API_BASE_URL}/api/questions/custom-industries`,
            {
              industryName: finalIndustry,
              userEmail: currentUser.email
            },
            {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          );
        } catch (error) {
          console.error('Error saving custom industry:', error);
          // Continue with question creation even if saving custom industry fails
        }
      }

      if (newQuestion.type === 'multiple_choice') {
        const validOptions = newQuestion.options.filter(opt => opt.trim() !== '');
        if (validOptions.length < 2) {
          toast.error('Please provide at least 2 options for multiple choice question');
          return;
        }
        if (!newQuestion.correctAnswer.trim()) {
          toast.error('Please specify the correct answer');
          return;
        }
        if (!validOptions.includes(newQuestion.correctAnswer)) {
          toast.error('Correct answer must be one of the options');
          return;
        }
      }

      let finalOptions = [];
      let finalCorrectAnswer = '';

      if (newQuestion.type === 'multiple_choice') {
        finalOptions = newQuestion.options.filter(opt => opt.trim() !== '');
        finalCorrectAnswer = newQuestion.correctAnswer.trim();
      }

      const questionData = {
        question: newQuestion.question.trim(),
        type: newQuestion.type,
        options: finalOptions,
        correctAnswer: finalCorrectAnswer,
        difficulty: newQuestion.difficulty,
        category: newQuestion.category.trim(),
        tags: newQuestion.tags.filter(tag => tag.trim() !== ''),
        timeLimit: parseInt(newQuestion.timeLimit) || 60,
        userEmail: currentUser.email,
        industry: finalIndustry,
        programmingLanguage: newQuestion.programmingLanguage,
        scenarioContext: newQuestion.scenarioContext,
        jobPosition: newQuestion.jobPosition.trim()
      };

      console.log('📤 Creating question for user email:', currentUser.email, questionData);

      const response = await axios.post(
        `${API_BASE_URL}/api/questions`, 
        questionData,
        {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data.success) {
        setShowCreateModal(false);
        resetNewQuestion();
        loadQuestions();
        loadCustomIndustries();
        toast.success("Question created successfully!");
      }
    } catch (error) {
      console.error('❌ Error creating question:', error);
      if (error.response?.data?.message) {
        toast.error(`Failed to create question: ${error.response.data.message}`);
      } else {
        toast.error('Failed to create question. Please try again.');
      }
    }
  };

  const resetNewQuestion = () => {
    setNewQuestion({
      question: '',
      type: 'multiple_choice',
      options: ['', '', ''],
      correctAnswer: '',
      difficulty: 'Medium',
      category: '',
      tags: [],
      timeLimit: 60,
      industry: 'it',
      customIndustry: '',
      programmingLanguage: '',
      scenarioContext: '',
      jobPosition: ''
    });
  };

  const updateOption = (index, value) => {
    const updatedOptions = [...newQuestion.options];
    updatedOptions[index] = value;
    setNewQuestion(prev => ({ ...prev, options: updatedOptions }));
  };

  const addOption = () => {
    setNewQuestion(prev => ({
      ...prev,
      options: [...prev.options, '']
    }));
  };

  const removeOption = (index) => {
    const updatedOptions = newQuestion.options.filter((_, i) => i !== index);
    setNewQuestion(prev => ({ ...prev, options: updatedOptions }));
    
    if (newQuestion.correctAnswer === newQuestion.options[index]) {
      setNewQuestion(prev => ({ ...prev, correctAnswer: '' }));
    }
  };

  const deleteQuestion = async (questionId) => {
    if (!window.confirm('Are you sure you want to delete this question?')) return;

    try {
      if (!currentUser) {
        toast.error('User not found. Please login again.');
        return;
      }

      const token = sessionStorage.getItem('authToken');
      const response = await axios.delete(
        `${API_BASE_URL}/api/questions/${questionId}`,
        {
          headers: { 
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          params: {
            userEmail: currentUser.email
          }
        }
      );

      if (response.data.success) {
        loadQuestions();
        toast.success('Question deleted successfully!');
      }
    } catch (error) {
      console.error('Error deleting question:', error);
      if (error.response?.data?.message) {
        toast.error(`Failed to delete question: ${error.response.data.message}`);
      } else {
        toast.error('Failed to delete question');
      }
    }
  };

  const getQuestionTypeLabel = (type) => {
    const allTypes = Object.values(questionTypesByIndustry).flat();
    const foundType = allTypes.find(t => t.value === type);
    return foundType ? foundType.label : type;
  };

  const getQuestionTypeIcon = (type) => {
    const allTypes = Object.values(questionTypesByIndustry).flat();
    const foundType = allTypes.find(t => t.value === type);
    return foundType ? foundType.icon : <HiOutlineQuestionMarkCircle />;
  };

  const getIndustryLabel = (industry) => {
    // Check if it's a predefined industry
    const foundIndustry = industries.find(ind => ind.value === industry);
    if (foundIndustry) return foundIndustry.label;
    
    // Check if it's a custom industry
    if (customIndustries.includes(industry)) return industry;
    
    // Default
    return industry || 'Custom Industry';
  };

  const getIndustryIcon = (industry) => {
    const foundIndustry = industries.find(ind => ind.value === industry);
    return foundIndustry ? foundIndustry.icon : <FaBuildingIcon />;
  };

  const addTag = () => {
    setNewQuestion(prev => ({
      ...prev,
      tags: [...prev.tags, '']
    }));
  };

  const removeTag = (index) => {
    setNewQuestion(prev => ({
      ...prev,
      tags: prev.tags.filter((_, i) => i !== index)
    }));
  };

  const updateTag = (index, value) => {
    setNewQuestion(prev => ({
      ...prev,
      tags: prev.tags.map((tag, i) => i === index ? value : tag)
    }));
  };

  const toggleQuestionDetails = (questionId) => {
    setActiveQuestion(activeQuestion === questionId ? null : questionId);
  };

  const getDifficultyColor = (difficulty) => {
    switch (difficulty.toLowerCase()) {
      case 'easy': return '#10b981';
      case 'medium': return '#f59e0b';
      case 'hard': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getCategoryPlaceholder = (industry) => {
    if (industry === 'other') {
      return "Enter category specific to your custom industry";
    }
    
    const placeholders = {
      it: "e.g., JavaScript, React, Algorithms, System Design",
      healthcare: "e.g., Cardiology, Nursing, Pharmacology, Medical Ethics",
      finance: "e.g., Investment, Risk Management, Accounting, Compliance",
      manufacturing: "e.g., Quality Control, Safety Procedures, Process Improvement",
      retail: "e.g., Customer Service, Inventory Management, Sales Techniques",
      education: "e.g., Teaching Methods, Classroom Management, Curriculum",
      hospitality: "e.g., Guest Services, Food Safety, Hotel Operations",
      logistics: "e.g., Supply Chain, Inventory Control, Transportation",
      construction: "e.g., Safety Protocols, Blueprint Reading, Materials",
      telecom: "e.g., Network Troubleshooting, Customer Service, Protocols",
      energy: "e.g., Safety Procedures, Technical Operations, Compliance",
      government: "e.g., Policy Knowledge, Public Service, Regulations"
    };
    return placeholders[industry] || "Enter category specific to your industry";
  };

  // Get industry filter options including custom industries
  const getIndustryFilterOptions = () => {
    const options = [...industries];
    
    // Add custom industries
    customIndustries.forEach(customInd => {
      options.push({
        value: customInd,
        label: `${customInd}`,
        icon: <FaBuildingIcon />
      });
    });
    
    return options;
  };

  return (
    <div className="qmb-main-container">
      {/* Animated Background */}
      <div className="qmb-background-animation">
        <div className="qmb-floating-shape qmb-shape-1"></div>
        <div className="qmb-floating-shape qmb-shape-2"></div>
        <div className="qmb-floating-shape qmb-shape-3"></div>
        <div className="qmb-pulse-dot qmb-pulse-1"></div>
        <div className="qmb-pulse-dot qmb-pulse-2"></div>
      </div>

      {/* Header Section */}
      <div className="qmb-header-section">
        <div className="qmb-header-content">
          <div className="qmb-header-title">
            <h1 className="qmb-main-title">
              <span className="qmb-title-icon"><HiOutlineDocumentText /></span>
              Question Bank
            </h1>
            <p className="qmb-subtitle">Manage assessment questions across all industries</p>
          </div>
          
          <div className="qmb-header-actions">
            {currentUser && (
              <div className="qmb-user-badge">
                <div className="qmb-user-avatar">
                  {currentUser.name?.charAt(0)?.toUpperCase() || 'U'}
                </div>
                <div className="qmb-user-info">
                  <span className="qmb-user-name">{currentUser.name}</span>
                  <span className="qmb-user-email">{currentUser.email}</span>
                </div>
              </div>
            )}
            
            <button 
              className="qmb-create-question-btn"
              onClick={() => setShowCreateModal(true)}
              disabled={!currentUser}
            >
              <span className="qmb-btn-icon"><FiPlus /></span>
              Create Question
            </button>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="qmb-stats-section">
        <div className="qmb-stats-grid">
          <div className="qmb-stat-card qmb-stat-primary">
            <div className="qmb-stat-icon">
              <HiOutlineDocumentText />
            </div>
            <div className="qmb-stat-content">
              <h3 className="qmb-stat-number">{stats.totalQuestions}</h3>
              <p className="qmb-stat-label">
                {industryFilter === 'all' ? 'Total Questions' : 
                 industryFilter === 'other' ? 'Custom Industry Questions' : 
                 `${getIndustryLabel(industryFilter)} Questions`}
              </p>
            </div>
          </div>

          <div className="qmb-stat-card qmb-stat-success">
            <div className="qmb-stat-icon">
              <FiCheckCircle />
            </div>
            <div className="qmb-stat-content">
              <h3 className="qmb-stat-number">{stats.multipleChoice}</h3>
              <p className="qmb-stat-label">Multiple Choice</p>
            </div>
          </div>

          <div className="qmb-stat-card qmb-stat-warning">
            <div className="qmb-stat-icon">
              <FiCode />
            </div>
            <div className="qmb-stat-content">
              <h3 className="qmb-stat-number">{stats.codingQuestions}</h3>
              <p className="qmb-stat-label">
                {industryFilter === 'it' ? 'Coding Questions' : 'Technical Questions'}
              </p>
            </div>
          </div>

          <div className="qmb-stat-card qmb-stat-info">
            <div className="qmb-stat-icon">
              <FiBookOpen />
            </div>
            <div className="qmb-stat-content">
              <h3 className="qmb-stat-number">{stats.scenarioQuestions}</h3>
              <p className="qmb-stat-label">
                {industryFilter === 'all' ? 'Scenario Based' : 'Case Studies'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Controls Section */}
      <div className="qmb-controls-section">
        <div className="qmb-search-filter">
          <div className="qmb-search-box">
            <span className="qmb-search-icon"><FiSearch /></span>
            <input
              type="text"
              placeholder={`Search ${getIndustryLabel(industryFilter).toLowerCase()} questions...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="qmb-search-input"
            />
          </div>

          <div className="qmb-industry-filter">
            <select
              value={industryFilter}
              onChange={(e) => {
                setIndustryFilter(e.target.value);
                setFilter('all');
                setJobPositionFilter('all');
              }}
              className="qmb-industry-select"
            >
              <option value="all"><FaBuildingIcon /> All Industries</option>
              {industries.filter(ind => ind.value !== 'all' && ind.value !== 'other').map(industry => (
                <option key={industry.value} value={industry.value}>
                  {industry.icon} {industry.label}
                </option>
              ))}
              {customIndustries.map(industry => (
                <option key={`custom-${industry}`} value={industry}>
                  <FaBuildingIcon /> {industry}
                </option>
              ))}
              <option value="other"><FiPlus /> Other Industries</option>
            </select>
          </div>

          {/* Job Position Filter */}
          <div className="qmb-job-position-filter">
            <select
              value={jobPositionFilter}
              onChange={(e) => setJobPositionFilter(e.target.value)}
              className="qmb-job-position-select"
            >
              <option value="all"><FiUsers /> All Job Positions</option>
              {jobPositions.map(position => (
                <option key={position} value={position}>
                  {position}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="qmb-filter-tabs">
          {currentIndustryTypes.map(type => (
            <button 
              key={type.value}
              className={`qmb-tab-btn ${filter === type.value ? 'qmb-tab-active' : ''}`}
              onClick={() => setFilter(type.value)}
            >
              <span className="qmb-tab-icon">{type.icon}</span>
              {type.label}
            </button>
          ))}
        </div>
      </div>

      {/* Error Message */}
      {!currentUser && (
        <div className="qmb-error-message">
          <div className="qmb-error-icon"><FiAlertCircle /></div>
          <div className="qmb-error-content">
            <h4>User Session Required</h4>
            <p>Please login again to manage your questions</p>
          </div>
        </div>
      )}

      {/* Questions Grid */}
      <div className="qmb-content-section">
        {loading ? (
          <div className="qmb-loading-state">
            <div className="qmb-loading-animation">
              <div className="qmb-loading-spinner"></div>
              <div className="qmb-loading-pulse"></div>
            </div>
            <p className="qmb-loading-text">Loading your questions...</p>
          </div>
        ) : (
          <div className="qmb-questions-grid">
            {filteredQuestions.length > 0 ? (
              filteredQuestions.map(question => (
                <div 
                  key={question._id} 
                  className={`qmb-question-card ${activeQuestion === question._id ? 'qmb-card-expanded' : ''}`}
                >
                  <div className="qmb-card-glow"></div>
                  
                  <div className="qmb-question-header">
                    <div className="qmb-question-type-badge">
                      <span className="qmb-type-icon">{getQuestionTypeIcon(question.type)}</span>
                      <span className="qmb-type-label">{getQuestionTypeLabel(question.type)}</span>
                    </div>
                    
                    <div className="qmb-question-meta">
                      <span className="qmb-industry-badge">
                        {getIndustryIcon(question.industry)} {getIndustryLabel(question.industry)}
                      </span>
                      {/* Job Position Badge */}
                      {question.jobPosition && (
                        <span className="qmb-job-position-badge">
                          <FiBriefcase /> {question.jobPosition}
                        </span>
                      )}
                      <span 
                        className="qmb-difficulty-badge"
                        style={{ 
                          backgroundColor: getDifficultyColor(question.difficulty),
                          color: 'white'
                        }}
                      >
                        {question.difficulty}
                      </span>
                      <span className="qmb-time-badge"><FiClock /> {question.timeLimit}s</span>
                    </div>
                  </div>

                  <div className="qmb-question-content">
                    <h4 className="qmb-question-text">{question.question}</h4>
                    
                    <div className="qmb-question-tags">
                      <span className="qmb-category-tag"><FiTag /> {question.category}</span>
                      {question.tags && question.tags.slice(0, 3).map((tag, index) => (
                        <span key={index} className="qmb-tag"><FiHash />{tag}</span>
                      ))}
                      {question.tags && question.tags.length > 3 && (
                        <span className="qmb-tag-more">+{question.tags.length - 3} more</span>
                      )}
                    </div>

                    {/* Expanded View */}
                    {activeQuestion === question._id && (
                      <div className="qmb-question-details">
                        {question.type === 'multiple_choice' && (
                          <div className="qmb-options-details">
                            <h5>Options:</h5>
                            <div className="qmb-options-list">
                              {question.options.map((option, idx) => (
                                <div 
                                  key={idx} 
                                  className={`qmb-option-item ${option === question.correctAnswer ? 'qmb-option-correct' : ''}`}
                                >
                                  <span className="qmb-option-letter">{String.fromCharCode(65 + idx)}</span>
                                  <span className="qmb-option-text">{option}</span>
                                  {option === question.correctAnswer && (
                                    <span className="qmb-correct-indicator"><FiCheckCircle /> Correct</span>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {(question.type === 'coding' || question.type === 'text') && (
                          <div className="qmb-description-details">
                            <div className="qmb-detail-item">
                              <strong><FiClock /> Time Limit:</strong> {question.timeLimit} seconds
                            </div>
                            {question.programmingLanguage && (
                              <div className="qmb-detail-item">
                                <strong><FiCode /> Programming Language:</strong> {question.programmingLanguage}
                              </div>
                            )}
                            {question.jobPosition && (
                              <div className="qmb-detail-item">
                                <strong><FiBriefcase /> Job Position:</strong> {question.jobPosition}
                              </div>
                            )}
                            <div className="qmb-detail-item">
                              <strong>{getIndustryIcon(question.industry)} Industry:</strong> {getIndustryLabel(question.industry)}
                            </div>
                            <div className="qmb-detail-item">
                              <strong><FiCalendar /> Created:</strong> {new Date(question.createdAt).toLocaleDateString()}
                            </div>
                          </div>
                        )}

                        {question.tags && question.tags.length > 0 && (
                          <div className="qmb-tags-details">
                            <strong><FiHash /> Tags:</strong>
                            <div className="qmb-tags-list">
                              {question.tags.map((tag, index) => (
                                <span key={index} className="qmb-detail-tag">#{tag}</span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="qmb-question-footer">
                    <div className="qmb-footer-actions">
                      <button 
                        className="qmb-view-details-btn"
                        onClick={() => toggleQuestionDetails(question._id)}
                      >
                        {activeQuestion === question._id ? (<><FiChevronUp /> Hide Details</>) : (<><FiChevronDown /> View Details</>)}
                      </button>
                      
                      <button 
                        className="qmb-delete-btn"
                        onClick={() => deleteQuestion(question._id)}
                        title="Delete Question"
                      >
                        <span className="qmb-delete-icon"><FiTrash2 /></span>
                        Delete
                      </button>
                    </div>
                    
                    <div className="qmb-created-info">
                      <span className="qmb-created-date">
                        <FiCalendar /> Created: {new Date(question.createdAt).toLocaleDateString()}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="qmb-empty-state">
                <div className="qmb-empty-animation">
                  <div className="qmb-empty-icon"><HiOutlineQuestionMarkCircle /></div>
                  <div className="qmb-empty-pulse"></div>
                </div>
                <h3 className="qmb-empty-title">
                  {industryFilter === 'all' ? 'No Questions Found' : 
                   industryFilter === 'other' ? 'No Custom Industry Questions' : 
                   `No ${getIndustryLabel(industryFilter)} Questions`}
                </h3>
                <p className="qmb-empty-description">
                  {currentUser 
                    ? `No questions found for ${getIndustryLabel(industryFilter).toLowerCase()} industry with current filters` 
                    : 'Please login to create and manage questions.'
                  }
                </p>
                {currentUser && (
                  <button 
                    className="qmb-create-first-btn"
                    onClick={() => setShowCreateModal(true)}
                  >
                    <span className="qmb-btn-icon"><FiPlus /></span>
                    Create {getIndustryLabel(industryFilter)} Question
                  </button>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Create Question Modal */}
      {showCreateModal && (
        <div className="qmb-modal-overlay">
          <div className="qmb-modal-content">
            <div className="qmb-modal-header">
              <div className="qmb-modal-title-section">
                <h3 className="qmb-modal-title">Create New Question</h3>
                {currentUser && (
                  <div className="qmb-user-indicator">
                    <FiUser /> Creating as: <strong>{currentUser.email}</strong>
                  </div>
                )}
              </div>
              <button 
                className="qmb-close-btn"
                onClick={() => {
                  setShowCreateModal(false);
                  resetNewQuestion();
                }}
              >
                <FiX />
              </button>
            </div>

            <div className="qmb-modal-body">
              {!currentUser ? (
                <div className="qmb-error-message">
                  <div className="qmb-error-icon"><FiAlertCircle /></div>
                  <div className="qmb-error-content">
                    <h4>Session Expired</h4>
                    <p>Please refresh the page and login again</p>
                  </div>
                </div>
              ) : (
                <div className="qmb-form-container">
                  {/* Job Position Selection Section */}
                  <div className="qmb-form-section">
                    <h4 className="qmb-form-section-title"><FiBriefcase /> Job Position Assignment</h4>
                    
                    <div className="qmb-form-group">
                      <label className="qmb-form-label">Select Job Position *</label>
                      <select
                        value={newQuestion.jobPosition}
                        onChange={(e) => {
                          const selectedPosition = e.target.value;
                          setNewQuestion(prev => ({ 
                            ...prev, 
                            jobPosition: selectedPosition
                          }));

                          // Auto-set industry and category based on selected position
                          if (selectedPosition) {
                            const department = getDepartmentFromPosition(selectedPosition);
                            const industry = getIndustryFromDepartment(department);
                            const suggestedCategories = getSuggestedCategories(selectedPosition);
                            
                            setNewQuestion(prev => ({
                              ...prev,
                              industry: industry,
                              category: suggestedCategories[0] || '',
                              tags: [...suggestedCategories.slice(0, 3), selectedPosition]
                            }));
                          }
                        }}
                        className="qmb-form-select"
                        required
                      >
                        <option value="">Select a Job Position</option>
                        {jobPositions.map(position => (
                          <option key={position} value={position}>
                            {position}
                          </option>
                        ))}
                      </select>
                      <div className="qmb-form-help">
                        <HiOutlineQuestionMarkCircle /> Select the job position this question is intended for
                      </div>
                    </div>

                    {/* Position Quick Suggestions */}
                    {jobPositions.length > 0 && (
                      <div className="qmb-position-suggestions">
                        <label className="qmb-form-label">Quick Select:</label>
                        <div className="qmb-suggestion-chips">
                          {jobPositions.slice(0, 6).map(position => (
                            <button
                              key={position}
                              type="button"
                              className={`qmb-suggestion-chip ${newQuestion.jobPosition === position ? 'qmb-suggestion-active' : ''}`}
                              onClick={() => {
                                const department = getDepartmentFromPosition(position);
                                const industry = getIndustryFromDepartment(department);
                                const suggestedCategories = getSuggestedCategories(position);
                                
                                setNewQuestion(prev => ({
                                  ...prev,
                                  jobPosition: position,
                                  industry: industry,
                                  category: suggestedCategories[0] || '',
                                  tags: [...suggestedCategories.slice(0, 3), position]
                                }));
                              }}
                            >
                              {position}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="qmb-form-section">
                    <h4 className="qmb-form-section-title"><FiGrid /> Industry & Category</h4>
                    
                    <div className="qmb-form-row">
                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Industry *</label>
                        <select
                          value={newQuestion.industry}
                          onChange={(e) => setNewQuestion(prev => ({ 
                            ...prev, 
                            industry: e.target.value,
                            customIndustry: e.target.value === 'other' ? prev.customIndustry : '',
                            type: 'multiple_choice'
                          }))}
                          className="qmb-form-select"
                        >
                          {getAllIndustries().map(industry => (
                            <option key={industry.value} value={industry.value}>
                              {industry.icon} {industry.label} {industry.isCustom ? '(Custom)' : ''}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Question Type *</label>
                        <select
                          value={newQuestion.type}
                          onChange={(e) => setNewQuestion(prev => ({ 
                            ...prev, 
                            type: e.target.value,
                            options: e.target.value === 'multiple_choice' ? ['', '', ''] : [],
                            correctAnswer: ''
                          }))}
                          className="qmb-form-select"
                        >
                          {(questionTypesByIndustry[newQuestion.industry] || questionTypesByIndustry.other).map(type => (
                            <option key={type.value} value={type.value}>
                              {type.icon} {type.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Custom Industry Input */}
                    {newQuestion.industry === 'other' && (
                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Custom Industry Name *</label>
                        <input
                          type="text"
                          value={newQuestion.customIndustry}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, customIndustry: e.target.value }))}
                          placeholder="Enter your custom industry name (e.g., Pharmaceuticals, Aerospace, Real Estate)"
                          className="qmb-form-input"
                          required
                        />
                        <div className="qmb-form-help">
                          <HiOutlineQuestionMarkCircle /> Type the name of your custom industry
                        </div>
                      </div>
                    )}

                    <div className="qmb-form-group">
                      <label className="qmb-form-label">Category *</label>
                      <input
                        type="text"
                        value={newQuestion.category}
                        onChange={(e) => setNewQuestion(prev => ({ ...prev, category: e.target.value }))}
                        placeholder={getCategoryPlaceholder(newQuestion.industry)}
                        className="qmb-form-input"
                        required
                        list="categories"
                      />
                      <datalist id="categories">
                        {categories.map((category, index) => (
                          <option key={index} value={category} />
                        ))}
                      </datalist>
                    </div>
                  </div>

                  <div className="qmb-form-section">
                    <h4 className="qmb-form-section-title"><HiOutlineDocumentText /> Question Basics</h4>
                    
                    <div className="qmb-form-row">
                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Difficulty Level</label>
                        <select
                          value={newQuestion.difficulty}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, difficulty: e.target.value }))}
                          className="qmb-form-select"
                        >
                          <option value="Easy"><FiCheckCircle style={{ color: '#10b981' }} /> Easy</option>
                          <option value="Medium"><FiAlertCircle style={{ color: '#f59e0b' }} /> Medium</option>
                          <option value="Hard"><FiAlertCircle style={{ color: '#ef4444' }} /> Hard</option>
                        </select>
                      </div>

                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Time Limit (seconds)</label>
                        <input
                          type="number"
                          value={newQuestion.timeLimit}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, timeLimit: parseInt(e.target.value) || 60 }))}
                          className="qmb-form-input"
                          min="30"
                          max="3600"
                        />
                      </div>
                    </div>

                    <div className="qmb-form-group">
                      <label className="qmb-form-label">Question Text *</label>
                      <textarea
                        value={newQuestion.question}
                        onChange={(e) => setNewQuestion(prev => ({ ...prev, question: e.target.value }))}
                        placeholder="Enter your question here... Be clear and specific."
                        rows="3"
                        className="qmb-form-textarea"
                        required
                      />
                    </div>
                  </div>

                  {/* Multiple Choice Options */}
                  {newQuestion.type === 'multiple_choice' && (
                    <div className="qmb-form-section">
                      <h4 className="qmb-form-section-title"><FiCheckCircle /> Multiple Choice Options</h4>
                      
                      <div className="qmb-options-container">
                        {newQuestion.options.map((option, index) => (
                          <div key={index} className="qmb-option-group">
                            <div className="qmb-option-input-row">
                              <span className="qmb-option-letter">{String.fromCharCode(65 + index)}</span>
                              <input
                                type="text"
                                placeholder={`Option ${String.fromCharCode(65 + index)}`}
                                value={option}
                                onChange={(e) => updateOption(index, e.target.value)}
                                className="qmb-option-input"
                              />
                              
                              <label className="qmb-correct-radio-label">
                                <input
                                  type="radio"
                                  name="correctAnswer"
                                  checked={newQuestion.correctAnswer === option}
                                  onChange={() => setNewQuestion(prev => ({ ...prev, correctAnswer: option }))}
                                  className="qmb-correct-radio"
                                />
                                <span className="qmb-radio-custom"></span>
                                <FiCheckCircle /> Correct
                              </label>
                              
                              {newQuestion.options.length > 2 && (
                                <button
                                  type="button"
                                  className="qmb-remove-option-btn"
                                  onClick={() => removeOption(index)}
                                  title="Remove Option"
                                >
                                  <FiMinus />
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                        
                        <button
                          type="button"
                          className="qmb-add-option-btn"
                          onClick={addOption}
                        >
                          <span className="qmb-add-icon"><FiPlus /></span>
                          Add Another Option
                        </button>
                        
                        {newQuestion.correctAnswer && (
                          <div className="qmb-correct-preview">
                            <span className="qmb-correct-icon"><FiCheckCircle /></span>
                            Correct Answer: <strong>"{newQuestion.correctAnswer}"</strong>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Coding Specific Fields */}
                  {newQuestion.type === 'coding' && (
                    <div className="qmb-form-section">
                      <h4 className="qmb-form-section-title"><FiCode /> Coding Challenge Details</h4>
                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Programming Language</label>
                        <select
                          value={newQuestion.programmingLanguage}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, programmingLanguage: e.target.value }))}
                          className="qmb-form-select"
                        >
                          <option value="">Select Language</option>
                          <option value="JavaScript">JavaScript</option>
                          <option value="Python">Python</option>
                          <option value="Java">Java</option>
                          <option value="C++">C++</option>
                          <option value="C#">C#</option>
                          <option value="PHP">PHP</option>
                          <option value="Ruby">Ruby</option>
                          <option value="Go">Go</option>
                          <option value="Swift">Swift</option>
                          <option value="Kotlin">Kotlin</option>
                          <option value="TypeScript">TypeScript</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>
                  )}

                  {/* Scenario Based Fields */}
                  {(newQuestion.type === 'scenario' || newQuestion.type === 'medical_scenario' || 
                    newQuestion.type === 'case_study' || newQuestion.type === 'patient_management') && (
                    <div className="qmb-form-section">
                      <h4 className="qmb-form-section-title"><FiTarget /> Scenario Context</h4>
                      <div className="qmb-form-group">
                        <label className="qmb-form-label">Scenario Description</label>
                        <textarea
                          value={newQuestion.scenarioContext}
                          onChange={(e) => setNewQuestion(prev => ({ ...prev, scenarioContext: e.target.value }))}
                          placeholder="Provide context for the scenario or case study..."
                          rows="3"
                          className="qmb-form-textarea"
                        />
                      </div>
                    </div>
                  )}

                  {/* Tags Section */}
                  <div className="qmb-form-section">
                    <h4 className="qmb-form-section-title"><FiTag /> Tags & Organization</h4>
                    
                    <div className="qmb-tags-container">
                      {newQuestion.tags.map((tag, index) => (
                        <div key={index} className="qmb-tag-group">
                          <input
                            type="text"
                            placeholder="Enter tag..."
                            value={tag}
                            onChange={(e) => updateTag(index, e.target.value)}
                            className="qmb-tag-input"
                          />
                          {newQuestion.tags.length > 1 && (
                            <button
                              type="button"
                              className="qmb-remove-tag-btn"
                              onClick={() => removeTag(index)}
                            >
                              <FiMinus />
                            </button>
                          )}
                        </div>
                      ))}
                      <button
                        type="button"
                        className="qmb-add-tag-btn"
                        onClick={addTag}
                      >
                        <span className="qmb-add-icon"><FiPlus /></span>
                        Add Tag
                      </button>
                    </div>
                  </div>

                  <div className="qmb-modal-actions">
                    <button
                      className="qmb-cancel-btn"
                      onClick={() => {
                        setShowCreateModal(false);
                        resetNewQuestion();
                      }}
                    >
                      <FiX /> Cancel
                    </button>
                    <button
                      className="qmb-create-btn"
                      onClick={handleCreateQuestion}
                      disabled={!newQuestion.question.trim() || 
                               !newQuestion.category.trim() || 
                               !newQuestion.jobPosition.trim() ||
                               (newQuestion.industry === 'other' && !newQuestion.customIndustry.trim())}
                    >
                      <span className="qmb-create-icon"><HiOutlineDocumentAdd /></span>
                      Create Question for {newQuestion.jobPosition || 'Position'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionsManager;